// @flow
import JQueryView, { on } from '../../common/JQueryView';

export default class DeleteView extends JQueryView {
  constructor() {
    super('#modal-delete-form');
  }

  @on({ event: 'change', selector: 'input[name="confirm"]' })
  onChangeCheck() {
    if (
      this.$el.find('.beauty-checkbox input:checkbox').length ==
      this.$el.find('.beauty-checkbox input:checkbox:checked').length
    ) {
      this.$el.find('a.btn').removeClass('disabled');
    } else {
      this.$el.find('a.btn').addClass('disabled');
    }
  }
}
